import { useConfigProperty } from '@leagueplatform/core';

const defaultConfig = {
  showGetAssistanceNowSubheading: false,
  showProviderAvailability: false,
};

export const useCareDiscoveryConfig = () =>
  useConfigProperty('careDiscovery', defaultConfig);
